// src/utils/audioPersist.js
import { globalAudio } from './globalAudio';

export const initAudioPersistence = () => {
  // Check if there's audio playing and restore it on page load
  const checkAndRestoreAudio = () => {
    const savedState = localStorage.getItem('audioPlayerState');
    if (savedState) {
      try {
        const state = JSON.parse(savedState);
        const now = Date.now();
        const timeDiff = now - (state.timestamp || 0);
        
        // Only restore if within 30 minutes
        if (timeDiff < 30 * 60 * 1000 && state.currentPodcast && state.currentTime > 0) {
          console.log('Restoring audio playback from persistence');
          
          // Get the current audio state
          const currentState = globalAudio.getState();
          
          // If nothing is currently playing, restore the saved state
          if (!currentState.currentPodcast || currentState.currentPodcast.id !== state.currentPodcast.id) {
            // We'll let the PodcastPlayer component handle the restoration
            // by checking the global audio state
          }
        }
      } catch (e) {
        console.error('Error parsing saved audio state:', e);
      }
    }
  };

  // Run on initialization
  checkAndRestoreAudio();

  // Save state before page unload
  window.addEventListener('beforeunload', () => {
    globalAudio.saveStateToStorage();
  });

  // Save state periodically
  setInterval(() => {
    globalAudio.saveStateToStorage();
  }, 10000); // Save every 10 seconds
};

// Initialize on import
initAudioPersistence();